import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Button, Container, CssBaseline, Backdrop, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
import axios from "axios";
import { genpostURL, genURL, getDataindb, GetCorServiceWithFallback } from "../../_getjson";

import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import CustomInput from "../../Components/CustomInput/CustomInput";
import Repostview from "../../Components/Reportview/Repostview";
import FullScreenDialog from "../../Components/CustomDialogs/Fullscreendialog";
import UseAutocompletes from "../../Components/CustomInput/UseAutocompletes";
import ProductSearch from "../../Components/ProductSearch/ProductSearch";
import ReportGmailerrorredRoundedIcon from "@mui/icons-material/ReportGmailerrorredRounded";
import Snackbar from "../../Components/Snackbar/Snackbar";
import CustomDatePicker from "../../Components/CustomDatepicker/CustomDatePicker";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import Typography from "@mui/material/Typography";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import moment from "moment";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

// Helper function to safely convert to number, handles null/undefined/empty string
// ชื่อตัวเลือกที่เป็นวันที่ (รองรับชื่อเดิมของรายงาน Jasper)
const DATE_OPTION_NAMES = ["startdate", "stopdate", "enddate"];

const toNum = (val) => {
  if (val === null || val === undefined || val === "") return 0;
  const num = Number(val);
  return isNaN(num) ? 0 : num;
};

export default function ListReport(props) {
  const { cateID, userSitecode } = props;
  const [reportData, setReportdata] = React.useState([]);
  const [reportID, setReportID] = React.useState(0);
  const [reportoption, setReportoption] = React.useState([]);
  const [reportoptionall, setReportoptionall] = React.useState([]);
  const [pathname, setPathname] = React.useState();
  const [choiceData, setchoiceData] = React.useState([]);
  const [choiceparms, setChoiceparms] = React.useState([]);
  // State แยกสำหรับแต่ละ field type
  const [siteData, setSiteData] = React.useState([]);
  const [brandData, setBrandData] = React.useState([]);
  const [typeData, setTypeData] = React.useState([]);
  const [modelData, setModelData] = React.useState([]);
  const [statusData, setStatusData] = React.useState([]);
  const [colorData, setColorData] = React.useState([]);
  const [dimension1Data, setDimension1Data] = React.useState([]);
  const [warehouseData, setWarehouseData] = React.useState([]);
  const [zoneData, setZoneData] = React.useState([]);
  const [locationData, setLocationData] = React.useState([]);
  const [mcgroupData, setMcgroupData] = React.useState([]);
  const [pettycashData, setPettycashData] = React.useState([]);
  const [urlsend, setURLsend] = React.useState("");
  const [openReportFullScreenDialog, setOpenReportFullScreenDialog] = React.useState(false);
  const [titleFullScreenDialog, setTitleFullScreenDialog] = React.useState("");
  const [isLoadingReport, setIsLoadingReport] = React.useState(false);
  const [autoClose, setAutoClose] = React.useState(3600);
  const [opensnackbar, setOpensnackbar] = React.useState(false);
  const [messagealert, setMessagealert] = React.useState("");
  const [color, setColor] = React.useState("info");
  const [icon, setIcon] = React.useState(null);
  const [expanded, setExpanded] = React.useState([]);
  const [cateReport, setCatereport] = React.useState([]);
  const [fullCateList, setFullCateList] = React.useState([]);
  const [arrayUniqueBycateid, setarrayUniqueBycateid] = React.useState([]);
  const [arrayDatacatelevel1, setarrayDatacatelevel1] = React.useState([]);
  const [arrayDatacatelevel2, setarrayDatacatelevel2] = React.useState([]);
  const [arrayDatacatelevel3, setarrayDatacatelevel3] = React.useState([]);
  const [arrayDatacatelevel4, setarrayDatacatelevel4] = React.useState([]);
  const [arrayDatacatelevel5, setarrayDatacatelevel5] = React.useState([]);
  const [arrayDatacatelevel6, setarrayDatacatelevel6] = React.useState([]);
  const [arrayDatacatelevel7, setarrayDatacatelevel7] = React.useState([]);
  const [arrayDatacatelevel8, setarrayDatacatelevel8] = React.useState([]);
  const [arrayDatacatelevel9, setarrayDatacatelevel9] = React.useState([]);

  // เลข request ล่าสุด ใช้ทิ้งผลลัพธ์ของ request เก่าที่ตอบกลับมาทีหลัง (เปลี่ยนหมวด / เปลี่ยนรายงาน / unmount)
  const cateRequestRef = React.useRef(0);
  const reportRequestRef = React.useRef(0);
  const retryTimerRef = React.useRef(null);

  const loadreportoptionData = useCallback(async (reportsID, reqId) => {
    const isStale = () => reqId !== reportRequestRef.current;
    if (!reportsID) {
      console.log('⚠️ loadreportoptionData - No reportID provided');
      return;
    }
    const url = `reportmanage/optionreport/${reportsID}?`;
    console.log('🔍 loadreportoptionData - URL:', url);
    console.log('🔍 loadreportoptionData - reportID:', reportsID);
    
    try {
      const res = await GetCorServiceWithFallback(url);
      if (isStale()) return;
      if (res === "error" || !res || !res.data) {
        console.error('❌ loadreportoptionData failed: Invalid response');
        setReportoption([]);
        return;
      }
      console.groupCollapsed(`📋 [Report] ตัวเลือกของรายงาน ${reportsID} (${res.data?.length || 0} รายการ)`);
      console.table((res.data || []).map((opt) => ({
        nameen: opt.Reportoptionnameen,
        nameth: opt.Reportoptionnameth,
        type: opt.Reportoptiontypenameen,
      })));
      console.groupEnd();
      
      const optionData = res.data || [];
      setReportoption(optionData);
      
      if (optionData.length === 0) {
        console.log('⚠️ loadreportoptionData - No options found for this report');
      }
    } catch (error) {
      if (isStale()) return;
      console.error('❌ loadreportoptionData - Error:', error);
      console.error('❌ loadreportoptionData - URL:', genURL(url));
      setReportoption([]);
    }
  }, []);

  function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  const loadreportData = useCallback(async (cateID, reqId, retryCount = 0) => {
    const isStale = () => reqId !== cateRequestRef.current;
    if (isStale()) return;
    const permissionGroup = localStorage.getItem("Permissiongroup");
    const token = localStorage.getItem("Token");
    
    // ตรวจสอบ Token ก่อน
    if (!token || token === "null" || token === "undefined") {
      console.error('❌ Token ไม่มีค่า! กรุณา login ใหม่');
      setReportdata([]);
      return;
    }
    
    // null = ยังไม่ได้ set (pslayout กำลัง fetch อยู่) → retry
    // "" = fetch เสร็จแล้วแต่ CODE ว่าง → หยุด retry
    if (permissionGroup === null || permissionGroup === "null" || permissionGroup === "undefined") {
      // Retry สูงสุด 10 ครั้ง รอ fetchPermissions ใน pslayout.js ให้เสร็จก่อน
      if (retryCount < 10) {
        retryTimerRef.current = setTimeout(() => loadreportData(cateID, reqId, retryCount + 1), 500);
        return;
      }
      console.error('❌ Permissiongroup ไม่มีค่า หลังจาก retry แล้ว');
      setReportdata([]);
      return;
    }

    if (permissionGroup === "") {
      console.error('❌ Permissiongroup ว่างเปล่า - ไม่พบสิทธิ์ผู้ใช้');
      setReportdata([]);
      return;
    }
    
    const url = `reportmanage/reportbypermision/${permissionGroup}/${cateID}?`;
    console.log('🔍 loadreportData URL:', url);
    console.log('👤 Permissiongroup:', permissionGroup);
    console.log('🔑 Token:', token ? 'EXISTS (length: ' + token.length + ')' : 'MISSING');
    console.log('📂 cateID:', cateID);
    
    try {
      const res = await GetCorServiceWithFallback(url);
      if (isStale()) return;
      if (res === "error" || !res || !res.data) {
        console.error('❌ loadreportData failed: Invalid response');
        setReportdata([]);
        return;
      }
      const element = res.data || [];
      console.log('✅ loadreportData response:', res.data);
      console.log('📊 Total reports:', res.data?.length);
      
      const grouped = groupBy(element, (resdata) => Number(resdata.catelevel));
      const refCategory = "refCategory";
      const arrayUniqueBycateid = [
        ...new Map(element.map((item) => [item[refCategory], item])).values(),
      ];
      
      // Batch state updates
      setReportdata(element);
      setarrayUniqueBycateid(arrayUniqueBycateid);
      setarrayDatacatelevel1(grouped.get(1) || []);
      setarrayDatacatelevel2(grouped.get(2) || []);
      setarrayDatacatelevel3(grouped.get(3) || []);
      setarrayDatacatelevel4(grouped.get(4) || []);
      setarrayDatacatelevel5(grouped.get(5) || []);
      setarrayDatacatelevel6(grouped.get(6) || []);
      setarrayDatacatelevel7(grouped.get(7) || []);
      setarrayDatacatelevel8(grouped.get(8) || []);
      setarrayDatacatelevel9(grouped.get(9) || []);
      
      console.log('📊 Reports by level:', {
        level1: (grouped.get(1) || []).length,
        level2: (grouped.get(2) || []).length,
        level3: (grouped.get(3) || []).length,
      });
    } catch (error) {
      if (isStale()) return;
      console.error('❌ loadreportData error:', error);
      console.error('❌ Error URL:', genURL(url));
      setReportdata([]);
    }
  }, []);

  const loadcatereport = useCallback(async (cateID, reqId) => {
    const isStale = () => reqId !== cateRequestRef.current;
    const url = `reportmanage/category?`;
    console.log('🔍 loadcatereport URL:', url);
    
    try {
      const res = await GetCorServiceWithFallback(url);
      if (isStale()) return;
      if (res === "error" || !res || !res.data) {
        console.warn('⚠️ loadcatereport: Cannot load categories (may be permission issue)');
        console.warn('💡 Setting empty category list');
        setCatereport([]);
        return; // Exit but don't treat as critical error
      }
      const element = res.data || [];
      console.log('✅ loadcatereport response:', res.data);
      console.log('📊 Total categories:', res.data?.length);
      
      setFullCateList(element);
      const groupedcate = groupBy(element, (resdata) => resdata.mainref);
      console.log('📂 Grouped by mainref:', groupedcate);
      console.log('🎯 Looking for cateID:', cateID, 'Type:', typeof cateID);
      
      const initial = groupedcate.get(Number(cateID)) || [];
      console.log('🎯 Initial categories for cateID', cateID, ':', initial);
      
      // Build lookup map (more efficient than repeated array access)
      const allById = element.reduce((acc, item) => {
        acc[Number(item.id)] = item;
        return acc;
      }, {});
      
      const renderMap = new Map();
      initial.forEach(node => renderMap.set(Number(node.id), node));
      
      // Build parent hierarchy
      for (const node of initial) {
        const visited = new Set();
        let parentId = Number(node.cateref) || 0;
        let depth = 0;
        
        while (parentId && !renderMap.has(parentId) && depth < 20) {
          if (visited.has(parentId)) break;
          visited.add(parentId);
          
          const parentNode = allById[parentId];
          if (!parentNode) break;
          
          renderMap.set(Number(parentNode.id), parentNode);
          parentId = Number(parentNode.cateref) || 0;
          depth++;
        }
      }
      
      const renderArray = Array.from(renderMap.values()).sort((a, b) => Number(a.id) - Number(b.id));
      console.log('📋 Final cateReport array:', renderArray);
      console.log('📋 cateReport length:', renderArray.length);
      setCatereport(renderArray);
    } catch (error) {
      if (isStale()) return;
      console.error('❌ loadcatereport error:', error);
      console.error('❌ loadcatereport error status:', error.response?.status);
      console.error('❌ loadcatereport error message:', error.response?.data);
      
      // ถ้าได้ 401 แปลว่า token มีปัญหา หรือ permission ไม่พอ
      if (error.response?.status === 401) {
        console.warn('⚠️ loadcatereport 401: Permission denied or token invalid');
        console.warn('💡 Tip: Check if this endpoint requires special permission');
      }
      
      setCatereport([]);
    }
  }, []);

  const handleClick = useCallback((e) => {
    console.log('🖱️ handleClick - Report selected:', e);
    console.log('🖱️ handleClick - Report ID:', e.id);
    console.log('🖱️ handleClick - Report Name:', e.nameTH);
    console.log('🖱️ handleClick - Report Path:', e.pathname);
    
    setReportID(e.id);
    setPathname(e.pathname.trim());
    
    if (e.id !== reportID) {
      console.log('🔄 handleClick - Resetting options (new report selected)');
      setReportoption([]);
      setReportoptionall([]);
    } else {
      console.log('ℹ️ handleClick - Same report clicked');
    }
    
    setTitleFullScreenDialog(e.nameTH);
  }, [reportID]);

  const handleBlur = useCallback((e, inputid, isDate = false) => {
    let val = "";
    if (e !== null && e !== undefined && e !== "") {
      if (isDate || DATE_OPTION_NAMES.includes(String(inputid).trim().toLowerCase())) {
        const m = moment(e);
        val = m.isValid() ? m.format("YYYY-MM-DD") : "";
      } else {
        val = String(e);
      }
    }
    // เก็บค่าล่าสุดของแต่ละช่อง (ค่าว่าง = ผู้ใช้ล้างค่า)
    setReportoptionall((prevRows) => [
      ...prevRows.filter((oldval) => oldval.inputname !== inputid),
      { inputname: inputid, val: val },
    ]);
  }, []);

  const btnhendleClick = useCallback(() => {
    // เริ่ม loading
    setIsLoadingReport(true);
    
    const keyname = "inputname";
    const newArrayinputUniqueByKey = [
      ...new Map(reportoptionall.map((item) => [item[keyname], item])).values(),
    ];
    
    // สร้าง Map สำหรับค้นหาค่าที่ user กรอกแล้ว
    const userInputMap = new Map(
      newArrayinputUniqueByKey.map(item => [String(item.inputname ?? "").trim(), String(item.val ?? "").trim()])
    );
    
    // วน loop ทุก field ใน reportoption และส่ง parameter ทุกตัว (ไม่ว่าจะมีค่าหรือค่าว่าง)
    const allParametersFromDB = reportoption
      .map(field => {
        const fieldName = String(field.Reportoptionnameen ?? "").trim();
        // ใช้ค่าที่ user กรอก หรือค่าว่างถ้าไม่มี
        let fieldValue = userInputMap.has(fieldName) ? userInputMap.get(fieldName) : '';
        // ไม่ได้เลือกสาขา ให้ใช้สาขาของผู้ใช้เป็นค่าเริ่มต้น (เหมือนเวอร์ชันเดิม)
        if (fieldName.toLowerCase() === 'sitecode' && fieldValue === '') {
          fieldValue = userSitecode || '';
        }
        // ✅ Encode แต่ละค่า parameter เพื่อป้องกัน double-encoding
        return `&${fieldName}=${encodeURIComponent(fieldValue)}`;
      })
      .join('');
    
    // เช็คว่ามี sitecode ใน reportoption หรือไม่
    const hasSitecodeInDB = reportoption.some(
      field => String(field.Reportoptionnameen ?? "").trim().toLowerCase() === 'sitecode'
    );
    
    // ถ้าไม่มี sitecode ใน DB ให้เพิ่มเข้าไป (encode sitecode ด้วย)
    const finalUrlReport = hasSitecodeInDB 
      ? allParametersFromDB 
      : `${allParametersFromDB}&sitecode=${encodeURIComponent(userSitecode || '')}`;
    
    // ✅ ใช้ backend proxy พร้อม parameters ครบถ้วนทุกตัวจาก DB
    const jasperReportUrl = `${process.env.REACT_APP_REPORTURL}${pathname}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}${finalUrlReport}`;
    
    
    // ส่ง URL ผ่าน backend proxy
    // iframe / แท็บใหม่ ส่ง Authorization header ไม่ได้ จึงต้องแนบ jwt ใน query string
    const proxyUrl = genURL(`reportmanage/proxy-jasper?url=${encodeURIComponent(jasperReportUrl)}`);
    
    // ---- Log สรุปก่อนเปิดรายงาน (ซ่อนรหัสผ่าน / token) ----
    const maskSecrets = (u) => String(u)
      .replace(/(j_password=)[^&]*/gi, "$1***")
      .replace(/(j_password%3D)[^&%]*/gi, "$1***")
      .replace(/(jwt=)[^&]*/gi, "$1***");
    console.group(`🧾 [Report] เรียกดู: ${titleFullScreenDialog} (id: ${reportID})`);
    console.log("pathname:", pathname);
    console.log("sitecode ผู้ใช้:", userSitecode);
    console.table(
      finalUrlReport
        .split("&")
        .filter(Boolean)
        .map((pair) => {
          const [name, ...rest] = pair.split("=");
          return { parameter: name, value: decodeURIComponent(rest.join("=")) };
        })
    );
    console.log("Jasper URL:", maskSecrets(jasperReportUrl));
    console.log("Proxy URL:", maskSecrets(proxyUrl));
    console.groupEnd();
    setURLsend(proxyUrl);
    setOpenReportFullScreenDialog(true);
    
    // ปิด loading หลังจาก 500ms (ให้เวลา dialog เปิด)
    setTimeout(() => {
      setIsLoadingReport(false);
    }, 500);
  }, [reportoptionall, reportoption, pathname, userSitecode, titleFullScreenDialog, reportID]);

  const CloseReportDialog = useCallback((e) => {
    setOpenReportFullScreenDialog(e);
    setIsLoadingReport(false);
  }, []);

  const setvalue = useCallback((e, type) => {
    if (e !== "") {
      const code = e[0].CODE;
      setReportoptionall((prevRows) => [
        ...prevRows.filter((oldval) => oldval.inputname !== type),
        { inputname: type, val: code },
      ]);

      // ถ้าเป็นการเลือก warehouse ให้ล้าง location ที่เลือกไว้ แล้วโหลด location ใหม่ตาม warehouse ที่เลือก
      if (type && type.trim().toLowerCase() === "warehouse") {
        console.log('🔄 Warehouse changed, loading locations for:', code);
        setReportoptionall((prevRows) =>
          prevRows.filter((oldval) => String(oldval.inputname ?? "").trim().toLowerCase() !== "location")
        );
        if (code) {
          loadLocation(code);
        } else {
          setLocationData([]);
        }
      }
    }
  }, []);

  // warehouse ที่ผู้ใช้เลือกอยู่ (ใช้โหลด location และ remount ช่อง location เมื่อเปลี่ยนคลัง)
  const selectedWarehouse = useMemo(() => {
    const found = [...reportoptionall]
      .reverse()
      .find((item) => String(item.inputname ?? "").trim().toLowerCase() === "warehouse");
    return found ? String(found.val ?? "") : "";
  }, [reportoptionall]);

  // Helper function สำหรับเลือกข้อมูลที่ถูกต้องตาม field type
  const getDataForField = useCallback((fieldType) => {
    switch (fieldType?.toLowerCase()) {
      case "sitecode": return siteData;
      case "brand": return brandData;
      case "type": return typeData;
      case "model": return modelData;
      case "status": return statusData;
      case "color": return colorData;
      case "dimension1": return dimension1Data;
      case "warehouse": return warehouseData;
      case "zone": return zoneData;
      case "location": return locationData;
      case "mcgroup": return mcgroupData;
      case "pettycashcode": return pettycashData;
      default: return choiceData;
    }
  }, [siteData, brandData, typeData, modelData, statusData, colorData, 
      dimension1Data, warehouseData, zoneData, locationData, mcgroupData, pettycashData, choiceData]);

  const onUseAutocompleteactivate = (val) => {
    console.log('🔍 onUseAutocompleteactivate - Field:', val);
    
    // โหลดข้อมูลเฉพาะเมื่อยังไม่มี (cache)
    if (val === "brand" && brandData.length === 0) {
      loadBrand();
    } else if (val === "sitecode" && siteData.length === 0) {
      loadSite();
    } else if (val === "type" && typeData.length === 0) {
      loadType();
    } else if (val === "model" && modelData.length === 0) {
      loadModel();
    } else if (val === "status" && statusData.length === 0) {
      loadStatus();
    } else if (val === "color" && colorData.length === 0) {
      loadColor();
    } else if (val === "zone" && zoneData.length === 0) {
      loadaszone();
    } else if (val === "mcgroup" && mcgroupData.length === 0) {
      loadasMcgroup();
    } else if (val === "pettycashcode" && pettycashData.length === 0) {
      loadPettycashcode();
    } else if (val === "dimension1" && dimension1Data.length === 0) {
      loadDimension1();
    } else if (val === "warehouse" && warehouseData.length === 0) {
      loadWarehouse();
    }
    else if (val === "location" && locationData.length === 0) {
      loadLocation(selectedWarehouse);
    }
    // Note: product is handled separately by ProductSearch component
  };
  // ---- load product ---- //
  // Used by ProductSearch component - returns data instead of setting state
  const loadProduct = async (searchText = "") => {
    console.log('🔍 loadProduct - Search text:', searchText);
    console.log('🔍 loadProduct - Search text length:', searchText.length);
    console.log('🔍 loadProduct - Encoded search text:', encodeURIComponent(searchText));
    
    const url = `CSPRODUCT/SearchMultiple?searchtext=${encodeURIComponent(searchText)}`;
    const fullURL = genURL(url);
    
    console.log('🔍 loadProduct - Full URL:', fullURL);
    
    try {
      const res = await axios.get(fullURL);
      const data = Array.isArray(res.data) ? res.data : []; 
      
      console.log('✅ loadProduct - Response received');
      console.log('🔍 loadProduct - Result count:', data.length);
      console.log('🔍 loadProduct - Full response data:', res.data);
      
      if (data.length > 0) {
        console.log('🔍 loadProduct - First item:', data[0]);
        console.log('🔍 loadProduct - First item keys:', Object.keys(data[0]));
      } else {
        console.log('⚠️ loadProduct - No data returned from API');
      }
      
      return data;
    } catch (error) {
      console.error('❌ Error loading products:', error);
      console.error('❌ Error details:', error.response?.data);
      console.error('❌ Error status:', error.response?.status);
      return [];
    }
  };
  // ---- end load product ---- //

  const loadasMcgroup = async () => {
    let url = "CSPDMAINGROUP/GetAll?";
    let elementmcgroup = [];
    await axios.get(genURL(url)).then((res) => {
      elementmcgroup = res.data;
    });
    setMcgroupData(elementmcgroup);
  };

  const loadPettycashcode = async () => {
    let url = "CSPETTYCASH/getAll?";
    let elementsite = [];
    await axios.get(genURL(url)).then((res) => {
      elementsite = res.data;
    });
    setPettycashData(elementsite);
  };

  const loadSite = async () => {
    let url = "CSSITE/Getsite?";
    let elementsite = [];
    
    await axios.get(genURL(url)).then((res) => {
      elementsite = res.data;

      console.log('🔍 loadSite Data:', res.data);

    });
    setSiteData(elementsite);
  };

  const loadBrand = async () => {
    let url = "CSPDSUBGROUP2/getAll?top=500?";
    let elementbrand = [];
    await axios
      .get(genURL(url))
      .then((res) => {
        elementbrand = res.data;
      })
      .catch((error) => {});
    setBrandData(elementbrand);
  };

  const loadType = async () => {
    let url = "CSPDSUBGROUP1/getAll?top=1000";
    let element = [];
    await axios
      .get(genURL(url))
      .then((res) => {
        element = res.data;
      })
      .catch((error) => {});
    setTypeData(element);
  };

  const loadModel = async () => {
    let url = "CSPDSUBGROUP4/getAll?top=2000";
    let element = [];
    await axios
      .get(genURL(url))
      .then((res) => {
        element = res.data;
      })
      .catch((error) => {});
    setModelData(element);
  };

  const loadStatus = async () => {
    let url = "CSPDSUBGROUP3/getAll?top=1000";
    let element = [];
    await axios
      .get(genURL(url))
      .then((res) => {
        element = res.data;
      })
      .catch((error) => {});
    setStatusData(element);
  };

  const loadColor = async () => {
    let url = "CSPDSUBGROUP5/getAll?top=1000";
    let element = [];
    await axios
      .get(genURL(url))
      .then((res) => {
        element = res.data;
      })
      .catch((error) => {});
    setColorData(element);
  };

  const loadDimension1 = async () => {
    let url = "CSDIMENSION1/getdata?";
    let element = [];
    await axios
      .get(genURL(url))
      .then((res) => {
        element = res.data;
      })
      .catch((error) => {});
    setDimension1Data(element);
  };

  const loadWarehouse = async () => {
    let url = "CSWAREHOUSE/CSwarehose?";
    let element = [];
    await axios
      .get(genURL(url))
      .then((res) => {
        element = res.data;
      })
      .catch((error) => {});
    setWarehouseData(element);
    
    // โหลด location ของ warehouse แรกเป็นค่าเริ่มต้น
    if (element && element.length > 0) {
      await loadLocation(element[0].CODE);
    }
  };

  const loadaszone = async () => {
    let url = "aszone/Zonedata?";
    let element = [];
    await axios
      .get(genURL(url))
      .then((res) => {
        element = res.data;
      })
      .catch((error) => {});
    setZoneData(element);
  };

  const loadLocation = async (warehouseCode) => {
    console.log('🔍 loadLocation - warehouseCode param:', warehouseCode);
    
    // ถ้าไม่ส่ง warehouseCode ให้ใช้ตัวแรกใน warehouseData (ถ้ายังไม่เคยโหลดคลัง ให้โหลดก่อน)
    let code = warehouseCode || (warehouseData && warehouseData.length > 0 ? warehouseData[0].CODE : null);
    if (!code) {
      try {
        const res = await axios.get(genURL("CSWAREHOUSE/CSwarehose?"));
        const warehouses = Array.isArray(res.data) ? res.data : [];
        setWarehouseData(warehouses);
        code = warehouses.length > 0 ? warehouses[0].CODE : null;
      } catch (error) {
        console.log('🔍 loadLocation - Load warehouse error:', error);
      }
    }
    
    if (code) {
      let url = "CSWAREHOUSE/CSlocation?warehousecode=" + code;
      console.log('🔍 loadLocation - Loading for warehouse:', code);
      
      let element = [];
      await axios
        .get(genURL(url))
        .then((res) => {
          console.log('🔍 loadLocation - Response:', res.data);
          element = res.data;
        })
        .catch((error) => {
          console.log('🔍 loadLocation - Error:', error);
        });
      setLocationData(element);
    } else {
      console.log('🔍 loadLocation - No warehouse code available');
      setLocationData([]);
    }
  };

  // Create lookup maps to avoid nested O(n^9) loops
  const cateReportMap = useMemo(() => {
    const map = new Map();
    cateReport.forEach(item => {
      map.set(Number(item.id), item);
    });
    return map;
  }, [cateReport]);

  const categoryByLevel = useMemo(() => {
    const map = new Map();
    map.set(1, arrayDatacatelevel1);
    map.set(2, arrayDatacatelevel2);
    map.set(3, arrayDatacatelevel3);
    map.set(4, arrayDatacatelevel4);
    map.set(5, arrayDatacatelevel5);
    map.set(6, arrayDatacatelevel6);
    map.set(7, arrayDatacatelevel7);
    map.set(8, arrayDatacatelevel8);
    map.set(9, arrayDatacatelevel9);
    return map;
  }, [
    arrayDatacatelevel1, arrayDatacatelevel2, arrayDatacatelevel3,
    arrayDatacatelevel4, arrayDatacatelevel5, arrayDatacatelevel6,
    arrayDatacatelevel7, arrayDatacatelevel8, arrayDatacatelevel9
  ]);

  const reportsByCategoryRef = useMemo(() => {
    const map = new Map();
    for (let level = 1; level <= 9; level++) {
      const levelData = categoryByLevel.get(level) || [];
      levelData.forEach(item => {
        const refCat = toNum(item.refCategory);
        if (!map.has(refCat)) {
          map.set(refCat, []);
        }
        map.get(refCat).push(item);
      });
    }
    return map;
  }, [categoryByLevel]);

  const categoriesByCateRef = useMemo(() => {
    const map = new Map();
    cateReport.forEach(item => {
      const cateRef = toNum(item.cateref);
      if (!map.has(cateRef)) {
        map.set(cateRef, []);
      }
      map.get(cateRef).push(item);
    });
    return map;
  }, [cateReport]);

  // Memoize StyledTreeItem to prevent unnecessary re-renders
  const StyledTreeItem = useMemo(() => styled((props) => {
    const { bgColor, color, labelText, ...other } = props;
    const { nodeId, ...rest } = other;
    const safeNodeId =
      nodeId !== undefined && nodeId !== null
        ? nodeId
        : String(labelText || "node").replace(/\s+/g, "_");
    return (
      <TreeItem
        nodeId={safeNodeId}
        label={
          <Box sx={{ display: "inline-grid", alignItems: "center", p: 0.1, pr: 0 }}>
            <Typography
              sx={{
                fontWeight: "inherit",
                fontFamily: "Customfont!important",
                flexGrow: 1,
              }}
            >
              {labelText}
            </Typography>
          </Box>
        }
        {...rest}
        style={{
          "--tree-view-color": color,
          "--tree-view-bg-color": bgColor,
        }}
      />
    );
  })(({ theme }) => ({
    textAlign: "justify",
  })), []);

  StyledTreeItem.propTypes = {
    bgColor: PropTypes.string,
    color: PropTypes.string,
    labelText: PropTypes.string.isRequired,
  };

  const handleToggle = useCallback((event, nodeIds) => {
    setExpanded(nodeIds);
  }, []);

  // Optimized recursive TreeView renderer using lookup maps - O(n) instead of O(n^9)
  const renderTreeNodes = useCallback((cateId, level = 1, marginLeft = "0px") => {
    const cateIdNum = toNum(cateId);
    const category = cateReportMap.get(cateIdNum);
    
    if (!category) return null;

    // Get reports for this category
    const reportsForThisCategory = reportsByCategoryRef.get(cateIdNum) || [];
    
    // Get child categories for this category
    const childCategories = categoriesByCateRef.get(cateIdNum) || [];

    return (
      <>
        {/* Render reports for this category */}
        {reportsForThisCategory.map((report) => (
          <StyledTreeItem
            key={`l${level}sub-${report.id}`}
            style={{ marginLeft }}
            nodeId={`l${level}sub${report.id}${report.id}`}
            labelText={`${category.nameEn}${report.id} - ${report.nameTH}`}
            color="#00aa80"
            bgColor="#e8f0fe"
            onClick={() => handleClick(report)}
          />
        ))}
        
        {/* Render child categories recursively */}
        {childCategories
          .filter(child => toNum(child.catelevel) === level + 1)
          .map((childCate) => {
            const childId = toNum(childCate.id);
            const nextMargin = `${(level + 1) * 10}px`;
            
            return (
              <StyledTreeItem
                key={`l${level + 1}main-${childId}`}
                style={{ marginLeft: nextMargin }}
                nodeId={`l${level + 1}main${childId}`}
                labelText={childCate.nameTH}
              >
                {renderTreeNodes(childId, level + 1, `${(level + 2) * 10}px`)}
              </StyledTreeItem>
            );
          })}
      </>
    );
  }, [cateReportMap, reportsByCategoryRef, categoriesByCateRef, handleClick]);

  // Get only level 1 categories for root nodes
  const rootCategories = useMemo(() => {
    return cateReport.filter(cat => toNum(cat.catelevel) === 1);
  }, [cateReport]);

  useEffect(() => {
    console.log('🔄 useEffect [cateID] triggered - cateID:', cateID);
    const reqId = ++cateRequestRef.current;
    loadreportData(cateID, reqId);
    loadcatereport(cateID, reqId);
    return () => {
      // ยกเลิก retry ที่ค้างอยู่ และทำให้ผลของ request นี้ถูกทิ้ง
      cateRequestRef.current++;
      clearTimeout(retryTimerRef.current);
    };
  }, [cateID, loadreportData, loadcatereport]);
  
  useEffect(() => {
    console.log('🔄 useEffect [reportID] triggered - reportID:', reportID);
    const reqId = ++reportRequestRef.current;
    if (reportID && reportID !== 0) {
      loadreportoptionData(reportID, reqId);
    } else {
      console.log('⚠️ useEffect [reportID] - Invalid reportID, skipping load');
    }
    return () => {
      reportRequestRef.current++;
    };
  }, [reportID, loadreportoptionData]);

  return (
    <React.Fragment>
      <CssBaseline />
      <Container fixed>
    
        {reportData.length > 0 && cateReport.length > 0 ? (
          <Box sx={{ flexGrow: 1, mt: { xs: 2, sm: 3, md: 4 } }}>
            <Grid container spacing={{ xs: 1, sm: 2 }}>
              <Grid item xs={12} md={8} lg={8}>
                <Item sx={{ p: { xs: 1, sm: 2 } }}>
                  <TreeView
                    aria-label="report"
                    defaultExpanded={[]}
                    expanded={expanded}
                    defaultCollapseIcon={<ArrowDropDownIcon />}
                    defaultExpandIcon={<ArrowRightIcon />}
                    defaultEndIcon={<div style={{ width: 24 }} />}
                    sx={{
                      minHeight: { xs: "200px", sm: "250px", md: "300px" },
                      maxHeight: { xs: "400px", sm: "500px", md: "600px", lg: "700px" },
                      flexGrow: 1,
                      overflowY: "auto",
                      fontSize: { xs: '0.875rem', sm: '0.9rem', md: '1rem' },
                    }}
                    onNodeToggle={handleToggle}
                  >
                    {rootCategories.map((rootCate) => {
                      const rootId = toNum(rootCate.id);
                      return (
                        <StyledTreeItem
                          key={`l1main-${rootId}`}
                          nodeId={`l1main${rootId}`}
                          labelText={rootCate.nameTH}
                        >
                          {renderTreeNodes(rootId, 1, "10px")}
                        </StyledTreeItem>
                      );
                    })}
                  </TreeView>
                </Item>
              </Grid>
 
              <Grid item xs={12} md={4} lg={4}>
                <Box sx={{ 
                  mb: { xs: 2, md: 0 },
                  p: { xs: 1, sm: 2 },
                  backgroundColor: { xs: '#fafafa', md: 'transparent' },
                  borderRadius: { xs: 1, md: 0 }
                }}>
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      mb: 2,
                      fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
                      fontFamily: "Customfont !important" 
                    }}
                  >
                    {titleFullScreenDialog}
                  </Typography>
                </Box>
                <Box sx={{ '& > *': { mb: { xs: 1.5, sm: 2 } } }}>
                  {reportoption.length > 0 ? (
                    <>
                      <Typography 
                        variant="caption" 
                        sx={{ 
                          display: 'block', 
                          mb: 1, 
                          color: 'text.secondary',
                          fontFamily: "Customfont !important" 
                        }}
                      >
                        📋 พบ {reportoption.length} ตัวเลือก
                      </Typography>
                      {Object.keys(reportoption).map(function (key, index) {
                        // Special handling for product field - use ProductSearch component
                        console.log('🔍 Rendering field:', reportoption[key].Reportoptionnameen, 'Type:', reportoption[key].Reportoptiontypenameen);
                        
                        // Default handling for other choice fields
                        return reportoption[
                          key
                        ].Reportoptiontypenameen?.trim().toLowerCase() === "choice" ? (
                          reportoption[key].Reportoptionnameen === "code" ? (
                            <Box key={`choice-${key}-${ reportoption[key].Reportoptionnameen}`}>
                              <ProductSearch
                                title={reportoption[key].Reportoptionnameth}
                                onSearch={loadProduct}
                                onSelect={(value) =>
                                  setvalue(value, reportoption[key].Reportoptionnameen)
                                }
                                placeholder="พิมพ์รหัส/ชื่อสินค้า แล้วกด Enter หรือปุ่มค้นหา"
                                minSearchLength={1}
                              />
                            </Box>
                          ) : (               
                          <Box key={`choice-${key}-${reportoption[key].Reportoptionnameen}${
                            String(reportoption[key].Reportoptionnameen ?? "").trim().toLowerCase() === "location" ? `-${selectedWarehouse}` : ""
                          }`}>

                            <UseAutocompletes
                              title={reportoption[key].Reportoptionnameth}
                              id={reportoption[key].Reportoptionnameen}
                              datalist={getDataForField(reportoption[key].Reportoptionnameen)}
                              valueReturn={(e) =>
                                setvalue(e, reportoption[key].Reportoptionnameen)
                              }
                              activate={(_) =>
                                onUseAutocompleteactivate(
                                  reportoption[key].Reportoptionnameen
                                )
                              }
                              placeholder={""}
                            />
                          </Box>
                        )) : reportoption[key].Reportoptiontypenameen?.trim().toLowerCase() ===
                          "date" ? (
                          <Box key={`date-${key}`}>
                            <CustomDatePicker
                              title={reportoption[key].Reportoptionnameth}
                              DateValue={(e) =>
                                handleBlur(e, reportoption[key].Reportoptionnameen, true)
                              }
                              defaultdate={""}
                            />
                          </Box>
                        ) : (
                          <Box key={`input-${key}`}>
                            <CustomInput
                              label={reportoption[key].Reportoptionnameth}
                              id={reportoption[key].Reportoptionnameen}
                              tabIndex={key}
                              inputType={reportoption[key].Reportoptiontypenameen}
                              resData={(e) =>
                                handleBlur(e, reportoption[key].Reportoptionnameen)
                              }
                              defaultValue=""
                            />
                          </Box>
                        );
                      })}
                    </>
                  ) : reportID && reportID !== 0 ? (
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        color: 'text.secondary', 
                        fontStyle: 'italic',
                        textAlign: 'center',
                        py: 2,
                        fontFamily: "Customfont !important" 
                      }}
                    >
                      ⏳ กำลังโหลดตัวเลือก...
                    </Typography>
                  ) : (
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        color: 'text.secondary', 
                        fontStyle: 'italic',
                        textAlign: 'center',
                        py: 2,
                        fontFamily: "Customfont !important" 
                      }}
                    >
                      กรุณาเลือกรายงานจากด้านซ้าย
                    </Typography>
                  )}
                </Box>
                {reportoption.length > 0 ? (
                  <Button
                    onClick={(_) => btnhendleClick()}
                    variant="outlined"
                    fullWidth
                    sx={{ 
                      mt: 2,
                      py: { xs: 1.5, sm: 1 },
                      fontSize: { xs: '0.9rem', sm: '0.875rem', md: '1rem' },
                      fontFamily: "Customfont !important" 
                    }}
                  >
                    เรียกดู
                  </Button>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </Box>
        ) : (
          ""
        )}
      </Container>
      <FullScreenDialog
        open={openReportFullScreenDialog}
        title={titleFullScreenDialog}
        CloseDialog={(e) => CloseReportDialog(e)}
      >
        <Repostview url={urlsend} />
      </FullScreenDialog>
      <Snackbar
        place="br"
        color={color}
        icon={icon}
        autoClose={autoClose}
        message={messagealert}
        open={opensnackbar}
        closeNotification={() => {
          setOpensnackbar(false);
        }}
        close
      />
      
      {/* Loading UI สำหรับการโหลดรายงาน */}
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(4px)',
        }}
        open={isLoadingReport}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <CircularProgress 
            size={60} 
            thickness={4}
            sx={{
              color: '#fff',
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Customfont !important",
              color: '#fff',
              textAlign: 'center',
              animation: 'pulse 1.5s ease-in-out infinite',
              '@keyframes pulse': {
                '0%, 100%': {
                  opacity: 1,
                },
                '50%': {
                  opacity: 0.5,
                },
              },
            }}
          >
            📊 กำลังโหลดรายงาน...
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontFamily: "Customfont !important",
              color: 'rgba(255, 255, 255, 0.7)',
              textAlign: 'center',
            }}
          >
            กรุณารอสักครู่
          </Typography>
        </Box>
      </Backdrop>
    </React.Fragment>
  );
}

ListReport.prototype = {
  cateID: PropTypes.string,
};
